import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API_ENDPOINTS } from "../config/api";
import "../styles/LiveDarshan.css";

const API_URL = API_ENDPOINTS.LIVE_DARSHAN;

const LiveDarshan = () => {
  /* ================= STATE ================= */

  const [liveData, setLiveData] = useState({
    title: "",
    subtitle: "",
    youtubeLink: "",
    liveBadge: "LIVE",
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  /* ================= FETCH ================= */

  const fetchLiveData = useCallback(async () => {
    try {
      setLoading(true);
      setError("");

      const res = await axios.get(API_URL);

      if (res.data) {
        setLiveData({
          title: res.data.title || "",
          subtitle: res.data.subtitle || "",
          youtubeLink: res.data.youtubeLink || "",
          liveBadge: res.data.liveBadge || "LIVE",
        });
      }
    } catch (error) {
      console.log("FETCH ERROR:", error.response?.data || error.message);
      setError("Failed to load live darshan. Please try again.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchLiveData();
  }, [fetchLiveData]);

  /* ================= YOUTUBE FIX ================= */

  const getYoutubeEmbedUrl = (url) => {
    if (!url) return "";

    if (url.includes("embed/")) return url;

    if (url.includes("youtu.be/")) {
      const id = url.split("youtu.be/")[1].split("?")[0];
      return `https://www.youtube.com/embed/${id}`;
    }

    if (url.includes("watch?v=")) {
      const id = url.split("watch?v=")[1].split("&")[0];
      return `https://www.youtube.com/embed/${id}`;
    }

    if (url.includes("live_stream")) return url;

    return url;
  };

  /* ================= UI ================= */

  if (loading) {
    return (
      <div className="live-darshan loading-screen">
        <p>Loading live darshan...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="live-darshan error-screen">
        <p>{error}</p>
        <button onClick={fetchLiveData}>Retry</button>
      </div>
    );
  }

  return (
    <div className="live-darshan">
      {/* HEADER */}
      <div className="ld-header">
        <h1>{liveData.title || "Live Darshan"}</h1>
        <p>{liveData.subtitle || "Divine blessings streaming live"}</p>
      </div>

      {/* LIVE STREAM */}
      <div className="ld-main-video">
        <div className="ld-live-badge">
          <span className="live-dot"></span>
          {liveData.liveBadge}
        </div>

        {liveData.youtubeLink && (
          <iframe
            src={getYoutubeEmbedUrl(liveData.youtubeLink)}
            title="Live Darshan"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
        )}
      </div>
    </div>
  );
};

export default LiveDarshan;